export const twoDigits = (val: number): string => (val < 10 ? `0${val}` : `${val}`);

export const createDateString = (
  year: string,
  month: string,
  day: number | ((date: Date) => number)
) => {
  if (typeof day === 'number') {
    return `${year}-${month}-${twoDigits(day)}`;
  }
  const date = new Date(parseInt(year), parseInt(month) - 1, 1);
  const lastDay = !isNaN(date.valueOf()) ? day(date) : 0;
  return `${year}-${month}-${twoDigits(lastDay)}`;
};

export const parseDateString = (dateString: string | number | undefined) => {
  const [year, month, day] = `${dateString}--`.split('-');
  return { year, month, day };
};
